import React from 'react'
import Users from '../../../components/customer/users/Users'

const CustomerUsers = () => {
    return <Users />
}

export default CustomerUsers
